// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__RJsWI","Initials":"Avatar_Initials__BWGDm","OverflowText":"Avatar_OverflowText__y5U8d"};